// ── QR DESACTIVADO ───────────────────────────────────────────────
export const QRDesactivadoScreen = () => (
  <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 text-center">
    <svg xmlns="http://www.w3.org/2000/svg" width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="#6b7280" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="4" y="11" width="16" height="10" rx="2" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
      <circle cx="12" cy="16" r="1" />
    </svg>
    <h1 className="mt-6 text-2xl font-bold text-gray-800">Acceso no disponible</h1>
    <p className="mt-2 max-w-xs text-sm text-gray-500">
      Este código QR ya no está activo. Contacta con tu responsable de almacén.
    </p>
  </div>
);
